import {
  readSearchKeyword,
  writeSearchKeyword,
  deleteSearchKeyword
} from "@/model/storage";
import { ApplianceList } from "@/types/common";
import { HistoryItem } from "@/types/search";
import { Recipe, RecipeImage } from "@/types/recipes";
import { CommonRecipe, CommonRecipeFoodId, CommonRecipeTag } from "@/types/commonRecipe";

const MAX_SEARCH_KEYWORD_COUNT = 20;

export const getTagName = (tag: string) => {
  return "#" + tag;
};

export const getRefinedTagName = (tag: string) => {
  return "#" + tag;
};
export const setSearchHistoryKeyword = (keyword: string) => {
  if (keyword == null || keyword == "") {
    return;
  }
  let data = readSearchKeyword();
  const list = data?.split(",");
  if (list != null) {
    for (let i = 0; i < list.length; i++) {
      if (list[i] == keyword) {
        return;
      }
    }
  }
  if (data == null || list == null) {
    data = keyword;
  } else if (list != null) {
    if (list.length >= MAX_SEARCH_KEYWORD_COUNT) {
      // 検索件数が超えた場合は、古いデータを削除する
      data = "";
      for (let i = 1; i < list.length; i++) {
        if (data != "") {
          data += ",";
        }
        data += list[i];
      }
    }
    if (data != "") {
      data += ",";
    }
    data += keyword;
  }
  writeSearchKeyword(data);
};

export const getSearchHistoryKeyword = () => {
  const data = readSearchKeyword();
  const list = Array<HistoryItem>();
  if (data != null) {
    const keywordList = data.split(",");
    if (keywordList != null) {
      for (let i = 0; i < keywordList.length; i++) {
        list.push(new HistoryItem(i, keywordList[i]));
      }
    }
  }
  return list;
};

export const deleteSearchHistoryKeyword = () => {
  deleteSearchKeyword();
};

export const getApplianceListText = (applianceList: ApplianceList) => {
  let applianceListText = "";
  if (applianceList != null) {
    applianceList.applianceList.forEach(e => {
      if (applianceListText != "") {
        applianceListText += " ";
      }
      applianceListText += e.productCode;
    });
  }
  if (applianceListText == "") {
    return null;
  }
  return applianceListText;
};

/**
 * レシピ画像を取得する
 */
export const getRecipeImage = (images: RecipeImage) => {
  if (images == null) {
    return "";
  }
  if (images.thumb != null) {
    return images.thumb;
  } else if (images.main != null) {
    return images.main;
  }
  return "";
};

/**
 * レシピ画像を取得する
 */
export const getRecipeImageMain = (images: RecipeImage[]) => {
  if (images == null || images.length == 0) {
    return "";
  }
  const image = images[0];
  if (image.main != null) {
    return image.main;
  } else if (image.thumb != null) {
    return image.thumb;
  }
  return "";
};

/** レシピ一覧系のAPIのレスポンスから、共通レシピ一覧への変換 */
export const createRecipeToCommonRecipe = (recipe: Recipe, foodIds: Array<CommonRecipeFoodId>) => {
  const element: CommonRecipe = new CommonRecipe();
  element.recipeId = recipe.recipeId;
  element.groupId = recipe.groupId;
  element.title = recipe.title;
  element.imageUrl = "";
  if (recipe.images != null && recipe.images.length != 0) {
    element.imageUrl = getRecipeImage(recipe.images[0]);
  }
  element.type = recipe.type;
  element.applianceCategory = recipe.applianceCategory;
  element.applianceCategoryId = recipe.applianceCategoryId;
  element.productId = recipe.productId;
  element.tags = [];
  element.foodIds = foodIds;
  for (const tag of recipe.tags) {
    element.tags.push(new CommonRecipeTag(tag.id, tag.name));
  }
  return element;
};

/** レシピ一覧系のAPIのレスポンスから、共通レシピ一覧への変換 */
export const createRecipeToCommonRecipes = (clips: Recipe[]) => {
  const commomList: CommonRecipe[] = [];
  if (clips.length >= 1) {
    for (let i = 0; i < clips.length; i++) {
      const recipe = clips[i];
      const element = createRecipeToCommonRecipe(recipe, []);
      commomList.push(element);
    }
  }
  return commomList;
};

/** レシピ一覧系のAPIのレスポンスから、共通レシピ一覧への変換 */
export const createRecipeToCommonRecipesRecommend = (clips: Recipe[]) => {
  const commomList: CommonRecipe[] = [];
  if (clips.length >= 1) {
    const size = clips.length >= 4 ? 4 : clips.length;
    for (let i = 1; i < size; i++) {
      const recipe = clips[i];
      const element = createRecipeToCommonRecipe(recipe, []);
      commomList.push(element);
    }
  }
  return commomList;
};

export const getViewedItemsString = (viewedItems: Array<string>) => {
  let items = "";
  for (const item of viewedItems) {
    items += item + ",";
  }
  items = items.slice(0, -1);
  return items;
}
